import React, { useEffect, useState, useContext } from 'react';
import { CircularProgress } from '@material-ui/core';
import UpdateTypeFormGenerator from '../../generators/UpdateTypeFormGenerator';
import { GlobalsContext } from '../../store/Globals';
import { InputType, InputTypes } from '../../store/inputs/types';
import { Container, LoadingContainer } from './styles';
import { UpdateTypeInputs, UpdatePropInput } from './utils';

const UpdateTypeFormScreen: React.FC<{
  asset: { label: string; tag: string };
}> = ({ asset }) => {
  const globals = useContext(GlobalsContext);
  const [inputs, setInputs] = useState<InputTypes[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getAssetInputs = async () => {
      setInputs(
        UpdateTypeInputs.map((ip: InputType) => ({
          ...ip,
          dataType: globals.dataTypeBase(ip.dataType),
          dropDownValues: globals.getDropDownValues(ip.dataType),
        })),
      );
      setInputs((prev) => [...prev, UpdatePropInput]);
      setLoading(false);
    };
    getAssetInputs();
  }, [asset.tag, globals]);

  if (loading)
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );

  return (
    <Container headerHeight={globals.headerHeight}>
      <UpdateTypeFormGenerator asset={{ name: asset, inputs }} />
    </Container>
  );
};

export default UpdateTypeFormScreen;
